import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the Audiences state domain
 */

const selectAudiencesDomain = state => state.Audiences || initialState;

/**
 * Other specific selectors
 */

const makeSelectItemsList = () =>
  createSelector(
    selectAudiencesDomain,
    substate => substate.itemsList,
  );

const makeSelectItemsListAllData = () =>
  createSelector(
    selectAudiencesDomain,
    substate => substate.allData,
  );

const makeSelectItemsListTotalAmount = () =>
  createSelector(
    selectAudiencesDomain,
    substate => substate.totalAmount,
  );

const makeSelectItemsListFilteringParams = () =>
  createSelector(
    selectAudiencesDomain,
    substate => substate.params,
  );

const makeSelectItemsTotalPages = () =>
  createSelector(
    selectAudiencesDomain,
    substate => substate.totalPages,
  );

const makeSelectItemsCurrentPage = () =>
  createSelector(
    selectAudiencesDomain,
    substate => substate.page,
  );
const makeSelectItemsLimitPerPage = () =>
  createSelector(
    selectAudiencesDomain,
    substate => substate.limit,
  );

const selectAudiencesLoading = () =>
  createSelector(
    selectAudiencesDomain,
    substate => substate.loading,
  );

const selectAudiencesError = () =>
  createSelector(
    selectAudiencesDomain,
    substate => substate.error,
  );

const makeSelectFirstRender = () =>
  createSelector(
    selectAudiencesDomain,
    substate => substate.firstRender,
  );



/**
 * Default selector used by Audiences
 */
const makeSelectAudiences = () =>
  createSelector(
    selectAudiencesDomain,
    substate => substate,
  );

export default makeSelectAudiences;
export {
  selectAudiencesDomain,
  selectAudiencesLoading,
  selectAudiencesError,
  makeSelectFirstRender,

  // list
  makeSelectItemsLimitPerPage,
  makeSelectItemsCurrentPage,
  makeSelectItemsTotalPages,
  makeSelectItemsListAllData,
  makeSelectItemsList,
  makeSelectItemsListFilteringParams,
  makeSelectItemsListTotalAmount,
};
